<template>
<div class="chapter">
<div class="inner_page">
<div id="Zulu.html" xml:lang="en-GB" xmlns:xml="http://www.w3.org/XML/1998/namespace">
<div class="story">
<p class="dedication"></p>
<p class="basic-paragraph"><em class="italic"> </em></p>
<h1 class="section" id="toc_marker-1"><span class="smallcaps">PART ONE</span><br/>
      THE HOT HAND</h1>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?64b1e906